import { ParseKeys } from 'i18next'

export const reasonsTerminationsKeys: ParseKeys[] = [
  'reasons terminations.emergency repair',
  'reasons terminations.days off',
  'reasons terminations.debt',
  'reasons terminations.accident',
  'reasons terminations.unsatisfactory work conditions',
  'reasons terminations.vehicle technical condition',
  'reasons terminations.moved to another city',
  'reasons terminations.joined another fleet',
  'reasons terminations.aggregator block',
  'reasons terminations.vehicle replacement',
  'reasons terminations.own vehicle',
  'reasons terminations.license revoked',
]
